export { getServerSideProps } from '@framework/ssr/shop';
import { getLayout } from '@components/layouts/layout';
import { ROUTES } from "@lib/routes";
import dynamic from 'next/dynamic';
import { isMobileOnly } from 'react-device-detect';
import { getLayout as getSiteLayoutMobile } from '@components/layouts/layout-mobile';
import { useShopQuery } from '@framework/shops/shops.query';

const Shop = dynamic(() => import("@framework/shops/shop"));

export default function ShopPage({ slug, locale }: any) {
  const {
    data,
    isLoading,
  } = useShopQuery(slug, locale);

  const breadCrumTitles = [
    {text: "text-home", url: ROUTES.HOME},
    {text: "text-all-shop-title", url: ROUTES.SHOPS},
    {text: data?.name, url: ""},
  ]

  return !isLoading && <Shop shop={data} breadCrumTitles={breadCrumTitles} />;
}

const getLayoutMobile = (page: React.ReactElement) =>
  getSiteLayoutMobile(
    <>{page}</>
  );

ShopPage.getLayout = isMobileOnly ? getLayoutMobile : getLayout;
